import { render, staticRenderFns } from "./EditKnow.vue?vue&type=template&id=1dd4634d&scoped=true"
import script from "./EditKnow.vue?vue&type=script&lang=js"
export * from "./EditKnow.vue?vue&type=script&lang=js"
import style0 from "./EditKnow.vue?vue&type=style&index=0&id=1dd4634d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd4634d",
  null
  
)

export default component.exports